import React, { useEffect } from 'react'
import ImageButton from '../utils/ImageButton'
import '../css/button.css'
import anime from 'animejs';
import lang from '../lang.json';

const Lettre = (props) => {

  const letter = props.letter;
  const x = props.x;
  const y = props.y;
  return (
    <div
      className={props.className}
      style={{
        backgroundColor: 'black',
        borderTop: '2px solid black',
        borderBottom: '2px solid black',
        borderRadius: '5px',
        position: 'absolute',
        width: '25px',
        height: '40px',
        top: `${y - 2}px`,
        left: `${x + 3}px`,
        zIndex: 4,
        opacity: 0,
      }}>
      <p style={{
        position: 'absolute',
        top: '-45px',
        left: '5px',
        fontSize: '40px',
        display: 'block',
        letterSpacing: '6px',
        color: 'white'
      }}>{letter}</p>
    </div>
  );
}

export default function Module3a(props) {

  const langue = props.langue;
  const texts = lang.lang[`lang_${langue}`].module3a;

  const yLetter = 0;
  const step = 26.6;
  const [isPlayingAnim1, setIsPlayingAnim1] = React.useState(false);
  const [isPlayingAnim2, setIsPlayingAnim2] = React.useState(false);

  const reset = () => {
    anime({
      targets: ['.firstRect', '.secondRect', '.thirdRect', '.letter16'],
      opacity: 0,
      duration: 0,
    })
    anime({
      targets: ['.letter'],
      opacity: 1,
      duration: 0,
    })
    anime({
      targets: ['.thirdRect'],
      left: 300, //PB rect 3 anim 1
      duration: 0,
    })
    anime({
      targets: ['.thirdAnimRect1'],
      width: 0,
      left: 0,
      opacity: 0,
      duration: 0,
    });
    anime({
      targets: ['.thirdAnimRect2'],
      width: 80,
      opacity: 0,
      duration: 0,
    });
  }

  const button1Handler = () => {
    reset();
    var tl = anime.timeline({
      //complete: callback
    })
    tl
      .set({
        update: () => setIsPlayingAnim2(false)
      })
      .set({
        update: () => setIsPlayingAnim1(false)
      })
      .add({
        targets: '.blanc-img-overlay',
        opacity: 0,
        duration: 0,
        complete: () => {
          const blancImg = document.querySelector('.blanc-img-overlay');
          if (blancImg && blancImg.parentNode) {
            blancImg.parentNode.removeChild(blancImg);
          }
        }
      })
      
      .add({
        targets: '.image',
        opacity: 1,
        duration: 0,
        complete: () => {
          // Show blanc.png image overlay
          const blancImg = document.createElement('img');
          blancImg.src = process.env.PUBLIC_URL + "/assets/images/module3a/abracadabra1.png";
          blancImg.alt = "blanc";
          blancImg.style.position = 'absolute';
          blancImg.style.top = '53px';
          blancImg.style.left = '23px';
          blancImg.style.width = '490px';
          blancImg.style.height = '57px';
          blancImg.style.zIndex = 3;
          blancImg.className = 'blanc-img-overlay';
          const displayDiv = document.querySelector('.display');
          if (displayDiv) {
            displayDiv.appendChild(blancImg);
          }
        }
      }, '+=0')
      .set({
        update: () => setIsPlayingAnim1(true)
      })
  }

  const button2Handler = () => {
    reset();
    var tl = anime.timeline({})
    tl
      .set({
        update: () => setIsPlayingAnim2(false)
      })
      .set({
        update: () => setIsPlayingAnim1(false)
      })
      .add({
        targets: '.blanc-img-overlay',
        opacity: 0,
        duration: 0,
        complete: () => {
          const blancImg = document.querySelector('.blanc-img-overlay');
          if (blancImg && blancImg.parentNode) {
            blancImg.parentNode.removeChild(blancImg);
          }
        }
      })
      .add({
        targets: '.thirdRect',
        left: 40,
        opacity: 1,
        duration: 0,
        easing: 'easeInSine',
      })
      .add({
        targets: '.thirdRect',
        left: 300,
        duration: 2000,
        easing: 'easeInSine',
      }, '+=100')

    var tl2 = anime.timeline({})
    tl2
      .add({
        targets: '.letter',
        opacity: 0,
        duration: 0,
      })
      .add({
        targets: '.letter',
        opacity: 1,
        duration: 10,
        easing: 'easeInSine',
      }, 2100)
      .set({
        update: () => setIsPlayingAnim2(true)
      })
  }

  const button3Handler = () => {
    reset();

    var audio = new Audio(process.env.PUBLIC_URL + '/assets/sounds/keypress.mp3');
    audio.play();

    const speed = 200;

    var tl = anime.timeline({})
    var tl2 = anime.timeline({})
    anime({
      targets: ['.thirdAnimRect1'],
      opacity: 1,
      duration: 0,
    });
    for (let i = 0; i <= 16; i++) {
      tl
        .set({
        update: () => setIsPlayingAnim1(false)
      })
      .set({
        update: () => setIsPlayingAnim2(false)
      })
      .set({
        update: () => setIsPlayingAnim2(false)
      })
      .set({
        update: () => setIsPlayingAnim1(false)
      })
      .add({
        targets: '.blanc-img-overlay',
        opacity: 0,
        duration: 0,
        complete: () => {
          const blancImg = document.querySelector('.blanc-img-overlay');
          if (blancImg && blancImg.parentNode) {
            blancImg.parentNode.removeChild(blancImg);
          }
        }
      })
        .add({
          targets: `.letter${i}`,
          opacity: 1,
          duration: 1,
        }, speed * i)
        .add({
          targets: `.letter${i}`,
          opacity: 0,
          duration: 1,
        }, `+=${speed}`)
        .add({
          targets: `.hider`,
          left: 26 * (i + 1),
          width: 440 - 26 * (i + 1),
          duration: 1,
        }, '+=0')
    }
    tl.add({
      targets: `.letter16`,
      opacity: 1,
      duration: 1,
    }, '+=0')

    for (let i = 0; i <= 12; i++) {
      tl2
        .add({
          targets: ".thirdAnimRect1",
          width: i * 26,
          duration: 1,
          easing: 'linear',
        }, speed * i)
    }
    tl2.add({
      targets: ".thirdAnimRect1",
      left: 28,
      duration: 200,
    }, speed * 4)

    tl2.add({
      targets: ".thirdAnimRect1",
      opacity: 0,
      duration: 10,
    }, '+=0')
    tl2.add({
      targets: ".thirdAnimRect2",
      opacity: 1,
      duration: 10,
    }, '+=0')
    for (let i = 12; i <= 16; i++) {
      tl2
        .add({
          targets: ".thirdAnimRect2",
          width: 73 + (i - 11) * 26,
          duration: 1,
          easing: 'linear',
        }, speed * i)
    }
  }

  useEffect(() => {
    //play a mp3 file
    var audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module3.mp3");
    audio.play();
    props.audio.push(audio)

    //sous titres
    let tl2 = anime.timeline({})
    //dabord opacity 0 pour tous
    tl2.add({
      targets: '.st',
      opacity: 0,
      duration: 1,
    })
    //puis on affiche le premier
    tl2.add({
      targets: '.st1',
      opacity: 1,
      duration: 1,
    }, 0)
    //puis on cache
    tl2.add({
      targets: '.st1',
      opacity: 0,
      duration: 1,
    }, 3000)
    //puis on affiche le deuxieme
    tl2.add({
      targets: '.st2',
      opacity: 1,
      duration: 1,
    }, 3000)
    //puis on cache
    tl2.add({
      targets: '.st2',
      opacity: 0,
      duration: 1,
    }, 6000)
    //puis on affiche tout
    tl2.add({
      targets: '.anim',
      opacity: 1,
      duration: 1000,
      easing: 'easeInSine',
    }, 6000)
    tl2.add({
      targets: '.anim2',
      opacity: 1,
      duration: 3000,
      easing: 'easeInSine',
    }, 7500)
  }, [])

  return (
    <>
      <div className='anim' style={{ opacity: '0' }}>
        <div
          className='selector'
          style={{ position: 'absolute', top: '40px', left: '20px', display: 'block', zIndex: 1 }}>
          <img
            src={process.env.PUBLIC_URL + "/assets/images/module3a/trunk.png"}
            style={{ position: 'absolute', top: '0px', left: '0px', display: 'block' }} />
          <ImageButton
            classNameForButton="rotateButton"
            dirName="module3a"
            id="1"
            x={50}
            y={30}
            callback={button1Handler}
            style={{ zIndex: 2, rotate: '-6deg', cursor: 'pointer' }} />
          <ImageButton
            classNameForButton="rotateButton"
            dirName="module3a"
            id="1"
            x={50}
            y={80}
            callback={button2Handler}
            style={{ zIndex: 2, rotate: '-8deg', cursor: 'pointer' }} />
          <ImageButton
            classNameForButton="rotateButton"
            dirName="module3a"
            id="1"
            x={50}
            y={130}
            callback={button3Handler}
            style={{ zIndex: 2, rotate: '-10deg', cursor: 'pointer' }} />
        </div>

        <div
          className='display'
          style={{
            position: 'absolute',
            width: '550px',
            height: '220px',
            top: '230px',
            left: '30px',
            display: 'block',
            backgroundColor: '#ffd35c',
            borderRadius: '5px'
          }}>
          <p style={{
            position: 'absolute',
            top: '15px',
            left: '45px',
            fontSize: '40px',
            display: 'block',
            letterSpacing: '6px',
          }}>
            abracadabrabradaca
          </p>

          {/*first anim */} 
          {isPlayingAnim1 && (
            <img
              src={process.env.PUBLIC_URL + "/assets/images/module3a/abracadabra1.png"}
              alt="abracadabra1"
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                zIndex: 10,
                width: '100%',
                height: '100%',
                objectFit: 'contain'
              }}
            />
          )}
          <div
            className='firstRect' //PB10 premier rectangle
            style={{
              backgroundOpacity: 0,
              border: '3px solid black',
              borderRadius: '5px',
              position: 'absolute',
              width: '128px',
              height: '40px',
              top: '57px',
              left: '38px',
              opacity: 0
            }}>
            <div
              style={{
                backgroundColor: 'black',
                borderTop: '2px solid black',
                borderBottom: '2px solid black',
                borderRadius: '5px',
                position: 'absolute',
                width: '23px',
                height: '40px',
                top: '-2px',
                right: '0px',
              }}>
              <p style={{
                position: 'absolute',
                top: '-45px',
                left: '3px',
                fontSize: '40px',
                display: 'block',
                letterSpacing: '6px',
                color: 'white',
              }}>c</p>
            </div>
          </div>

          <div
            className='secondRect'
            style={{
              backgroundOpacity: 0,
              border: '3px solid black',
              borderRadius: '5px',
              position: 'absolute',
              width: '128px',
              height: '40px',
              top: '57px',
              left: '224px',
              opacity: 0
            }}>
            <div
              style={{
                backgroundColor: 'black',
                borderTop: '2px solid black',
                borderBottom: '2px solid black',
                borderRadius: '5px',
                position: 'absolute',
                width: '23px',
                height: '40px',
                top: '-2px',
                right: '0px',
              }}>
              <p style={{
                position: 'absolute',
                top: '-45px',
                left: '2px',
                fontSize: '40px',
                display: 'block',
                letterSpacing: '6px',
                color: 'white'
              }}>b</p>
            </div>
          </div>

          <div
            className='thirdRect'
            style={{
              backgroundOpacity: 0,
              border: '3px solid black',
              borderRadius: '5px',
              position: 'absolute',
              width: '120px',
              height: '40px',
              top: '57px',
              left: '294px', //ne sert a rien
              opacity: 0
            }}>
            <div
              className='letter'
              style={{
                backgroundColor: 'black',
                borderTop: '2px solid black',
                borderBottom: '2px solid black',
                borderRadius: '5px',
                position: 'absolute',
                width: '25px',
                height: '40px',
                top: '-2px',
                right: '0px',
                opacity: 0
              }}>
              <p style={{
                position: 'absolute',
                top: '-45px',
                left: '2px',
                fontSize: '40px',
                display: 'block',
                letterSpacing: '6px',
                color: 'white'
              }}>d</p>
            </div>
          </div>

          <div className='thirdAnim'
            style={{
              position: 'absolute',
              top: '140px',
              left: '35px',
            }}
          >
            <p style={{
              position: 'absolute',
              top: '-44px',
              left: '5px',
              fontSize: '40px',
              display: 'block',
              letterSpacing: '6px',
            }}>
              dacadabrabracada
            </p>
            <Lettre
              className='letter1'
              letter='d'
              x={0 * step}
              y={yLetter}
            />
            <Lettre
              className='letter2'
              letter='a'
              x={1 * step}
              y={yLetter}
            />
            <Lettre
              className='letter3'
              letter='c'
              x={2 * step}
              y={yLetter}
            />
            <Lettre
              className='letter4'
              letter='a'
              x={3 * step}
              y={yLetter}
            />
            <Lettre
              className='letter5'
              letter='d'
              x={4 * step}
              y={yLetter}
            />
            <Lettre
              className='letter6'
              letter='a'
              x={5 * step}
              y={yLetter}
            />
            <Lettre
              className='letter7'
              letter='b'
              x={6 * step}
              y={yLetter}
            />
            <Lettre
              className='letter8'
              letter='r'
              x={7 * step}
              y={yLetter}
            />
            <Lettre
              className='letter9'
              letter='a'
              x={8 * step}
              y={yLetter}
            />
            <Lettre
              className='letter10'
              letter='b'
              x={9 * step}
              y={yLetter}
            />
            <Lettre
              className='letter11'
              letter='r'
              x={10 * step}
              y={yLetter}
            />
            <Lettre
              className='letter12'
              letter='a'
              x={11 * step}
              y={yLetter}
            />
            <Lettre
              className='letter13'
              letter='c'
              x={12 * step}
              y={yLetter}
            />
            <Lettre
              className='letter14'
              letter='a'
              x={13 * step}
              y={yLetter}
            />
            <Lettre
              className='letter15'
              letter='d'
              x={14 * step}
              y={yLetter}
            />
            <Lettre
              className='letter16'
              letter='a'
              x={14.8 * step}
              y={yLetter}
            />
            <div
              className='thirdAnimRect1'
              style={{
                backgroundOpacity: 0,
                border: '3px solid black',
                borderRadius: '5px',
                position: 'absolute',
                width: '24px',
                height: '40px',
                top: '-2px',
                left: '0px',
                opacity: 1
              }}></div>
            <div
              className='thirdAnimRect2'
              style={{
                backgroundOpacity: 0,
                border: '3px solid black',
                borderRadius: '5px',
                position: 'absolute',
                width: '80px',
                height: '40px',
                top: '-2px',
                left: '214px',
                opacity: 1
              }}></div>
            <div
              className='hider'
              style={{
                backgroundColor: '#ffd35c',
                position: 'absolute',
                width: '442px',
                height: '80px',
                top: '-20px',
                left: '0px',
              }}></div>
          </div>
        </div>
      </div>

      {/* textes */}
      <p
        style={{
          position: 'absolute',
          left: 10,
          top: 0,
          color: 'white',
          fontSize: '15px',
          zIndex: 15
        }}
      >{texts.lang1}</p>

      {/* sous titres */}
      <p
        className="st1 st"
        style={{
          position: 'absolute',
          top: '412px',
          left: '10px',
          opacity: 1,
          color: 'white',
          backgroundColor: 'black',
          backgroundOpacity: 0.5,
          padding: '5px',
        }}
      >
        {texts.lang24}
      </p>
      <p
        className="st2 st"
        style={{
          position: 'absolute',
          top: '412px',
          left: '10px',
          opacity: 1,
          color: 'white',
          backgroundColor: 'black',
          backgroundOpacity: 0.5,
          padding: '5px',
          zIndex: 18,
        }}
      >
        {texts.lang25}
      </p>
      <p
        className="anim"
        style={{
          position: 'absolute',
          left: 120,
          top: 10,
          width: 526,
          color: 'white',
          fontSize: '13px',
          zIndex: 1,
          opacity: 0,
        }}>{texts.lang30}</p>
      <p
        className='anim2'
        style={{
          position: 'absolute',
          left: 118,
          top: 60,
          width: 526,
          color: 'white',
          fontSize: '13px',
          zIndex: 1,
          opacity: 0,
        }}>{texts.lang31}</p>
      <p
        className='anim2'
        style={{
          position: 'absolute',
          left: 118,
          top: 103,
          width: 526,
          color: 'white',
          fontSize: '13px',
          zIndex: 1,
          opacity: 0,
        }}>{texts.lang32}</p>
      <p
        className='anim2'
        style={{
          position: 'absolute',
          left: 118,
          top: 138,
          width: 526,
          color: 'white',
          fontSize: '13px',
          zIndex: 1,
          opacity: 0,
        }}>{texts.lang33}</p>
    </>
  )
}
